module.exports = __webpack_public_path__ + "static/media/main idea.5b4cfe20.mp3";